define('brands_list.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('brands_list', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"userpreferences-list-table\"><div data-view=\"BrandsPage.List.Collection.View\"></div></div>";
},"useData":true}, 'extensions/PSeComm/JeskeBrandsPage/1.0.1/', 'extensions/PSeComm/JeskeBrandsPage/1.0.1/', Handlebars);
});